!function() {
  "use strict";
  
  const newsletterFormSelector = "[data-newsletter-form]";
  const newsletterHeadingSelector = "[data-newsletter-heading]";
  const successClass = "has-success";
  const errorClass = "has-error";
  const hiddenClass = "hidden";
  
  if (!customElements.get("newsletter-component")) {
    customElements.define("newsletter-component", class extends HTMLElement {
      constructor() {
        super();
        this.newsletter = this.querySelector(newsletterFormSelector);
        this.sessionStorage = window.sessionStorage;
        this.stopSubmit = true;
        this.formID = null;
      }
      
      connectedCallback() {
        if (window.location.pathname !== "/challenge") {
          this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e);
          this.newsletter.addEventListener("submit", this.newsletterSubmit);
          this.showMessage();
        }
      }
      
      newsletterSubmitEvent(e) {
        if (this.stopSubmit) {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.removeStorage();
          this.writeStorage();
          this.stopSubmit = false;
          this.newsletter.submit();
        }
      }
      
      writeStorage() {
        if (this.sessionStorage !== undefined) {
          this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
        }
      }
      
      readStorage() {
        this.formID = this.sessionStorage.getItem("newsletter_form_id");
      }
      
      removeStorage() {
        this.sessionStorage.removeItem("newsletter_form_id");
      }
      
      showMessage() {
        this.readStorage();
        
        if (this.newsletter.id === this.formID) {
          const form = document.getElementById(this.formID);
          const heading = form.parentElement.querySelector(newsletterHeadingSelector);
          const isSuccess = window.location.search.indexOf("?customer_posted=true") !== -1;
          const isError = window.location.search.indexOf("accepts_marketing") !== -1;
          
          if (isSuccess) {
            form.classList.remove(errorClass);
            form.classList.add(successClass);
            if (heading) {
              heading.classList.add(hiddenClass);
              form.classList.remove(hiddenClass);
            }
          } else if (isError) {
            form.classList.remove(successClass);
            form.classList.add(errorClass);
            if (heading) {
              heading.classList.add(hiddenClass);
              form.classList.remove(hiddenClass);
            }
          }
          
          // Scroll behavior removed - no longer scrolling to form after submission
        }
      }
    });
  }
}();
